import {
  Heart,
  ExternalLink,
  FileText,
  Shield,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { ROUTES } from '../../constants/routes';

export function AboutPage() {
  return (
    <StaticPageLayout title="About Fash">
      <div className="text-center py-4">
        <h2 className="text-5xl font-serif text-primary mb-3">Fash</h2>
        <p className="text-sm text-body">Version 1.0.0</p>
        <p className="text-sm text-body mt-1">Local boutique delivery, reimagined</p>
      </div>

      <Card>
        <CardContent className="p-5">
          <h3 className="font-serif text-lg text-heading mb-2">Our Mission</h3>
          <p className="text-sm text-body leading-relaxed">
            Fash connects shoppers with independent local boutiques for same-day fashion delivery.
            We believe in supporting small businesses and making unique, curated fashion accessible
            to everyone.
          </p>
        </CardContent>
      </Card>

      <div>
        <h2 className="text-sm font-medium text-body uppercase tracking-wider mb-3 px-1">
          Legal
        </h2>
        <Card>
          <CardContent className="p-0 divide-y divide-gray-100">
            <Link
              to={ROUTES.terms}
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center space-x-3">
                <FileText className="h-5 w-5 text-body" />
                <span className="text-sm font-medium text-heading">Terms of Service</span>
              </div>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
            <Link
              to={ROUTES.privacy}
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center space-x-3">
                <Shield className="h-5 w-5 text-body" />
                <span className="text-sm font-medium text-heading">Privacy Policy</span>
              </div>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
            <Link
              to="/merchant-agreement"
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center space-x-3">
                <FileText className="h-5 w-5 text-body" />
                <span className="text-sm font-medium text-heading">Merchant Agreement</span>
              </div>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
          </CardContent>
        </Card>
      </div>

      <div>
        <h2 className="text-sm font-medium text-body uppercase tracking-wider mb-3 px-1">
          More
        </h2>
        <Card>
          <CardContent className="p-0 divide-y divide-gray-100">
            <Link
              to="/changelog"
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-heading">Changelog</span>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
            <Link
              to={ROUTES.faq}
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-heading">FAQ</span>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
            <Link
              to={ROUTES.careers}
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-heading">Careers</span>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
            <Link
              to={ROUTES.press}
              className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-heading">Press</span>
              <ExternalLink className="h-4 w-4 text-gray-400" />
            </Link>
          </CardContent>
        </Card>
      </div>

      <div className="text-center text-sm text-body py-2">
        <p className="flex items-center justify-center">
          Made with <Heart className="h-3.5 w-3.5 text-red-500 mx-1" /> in NYC
        </p>
      </div>
    </StaticPageLayout>
  );
}
